import { render, staticRenderFns } from "./vLogin.vue?vue&type=template&id=5bacf21d&scoped=true"
import script from "./vLogin.vue?vue&type=script&lang=js"
export * from "./vLogin.vue?vue&type=script&lang=js"
import style0 from "./vLogin.vue?vue&type=style&index=0&id=5bacf21d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bacf21d",
  null
  
)

export default component.exports